import React, { useState } from "react";
import {
    Box,
    Button,
    Heading,
    VStack,
    Text,
    Image,
    Input,
    useToast,
    Flex,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { designBackgroundApi } from "../../../api/designBackground";
import StepHeader from "./StepHeader";

export default function Step2Upload() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const toast = useToast();

    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState("");

    if (!state?.name) {
        return (
            <Box p={6}>
                <Text>Thiếu dữ liệu. Hãy bắt đầu lại từ Step 1.</Text>
            </Box>
        );
    }

    const handleChooseFile = (e) => {
        const f = e.target.files?.[0];
        if (!f) return;
        setFile(f);
        setPreview(URL.createObjectURL(f));
    };

    const handleUpload = async () => {
        if (!file) {
            toast({
                status: "error",
                title: "Vui lòng chọn ảnh",
                position: "bottom-right"
            });
            return;
        }

        // Tạo trạng thái toast loading
        const loadingToast = toast({
            status: "loading",
            title: "Đang upload...",
            duration: null,
            isClosable: false,
            position: "bottom-right"
        });

        try {
            const res = await designBackgroundApi.uploadBannerImage(file);

            // close toast loading
            toast.close(loadingToast);

            toast({
                status: "success",
                title: "Upload thành công!",
                position: "bottom-right"
            });

            navigate("/design-background/create/step3", {
                state: {
                    name: state.name,
                    imageUrl: res.filePath,
                },
            });
        } catch (err) {
            toast.close(loadingToast);

            toast({
                status: "error",
                title: "Upload thất bại!",
                position: "bottom-right"
            });
        }
    };

    return (
        <Box p={6} w={"full"} display={"flex"} alignItems={"center"} flexDirection={"column"}>
            <StepHeader step={1} />

            <Box maxW="480px">
                <Heading size="md" mb={4}>
                    Bước 2: Tải ảnh Banner
                </Heading>
                <VStack spacing={4} align="stretch">
                    <Box>
                        <Flex mb={1} alignItems="center" gap="4px">
                            {"Chọn file ảnh"}{" "}
                            <Text color={"red"} lineHeight={"15px"}>
                                *
                            </Text>
                        </Flex>
                        
                        <Flex
                            w="480px"
                            border="1px solid #d0d5dd"
                            borderRadius="8px"
                            overflow="hidden"
                            alignItems="center"
                        >
                            <Box
                                flex="1"
                                px="12px"
                                py="8px"
                                fontSize="14px"
                                color={file ? "gray.800" : "gray.500"}
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                            >
                                {file ? file.name : "Chưa có file nào được chọn"}
                            </Box>

                            {/* Nút chọn file */}
                            <Box bg="blue.500" color="white" px="16px" py="8px" fontSize="14px">
                                <label htmlFor="uploadInput" style={{ cursor: "pointer" }}>
                                    Chọn file
                                </label>
                            </Box>

                            <Input
                                id="uploadInput"
                                type="file"
                                accept="image/*"
                                onChange={handleChooseFile}
                                display="none"
                            />
                        </Flex>
                    </Box>

                    {preview && (
                        <Image
                            src={preview}
                            alt="preview"
                            borderRadius="md"
                            border="1px solid #ddd"
                            maxH="380px"
                            objectFit="contain"
                        />
                    )}
                    <Button colorScheme="blue" onClick={handleUpload}>
                        Tiếp tục
                    </Button>
                </VStack>
            </Box>
        </Box>
    );
}
